import { CitiesRepository } from '../repositories/cities.repository'
import {
    CityPayloadT,
    CityResponseT,
    GetAllCitiesResponseT,
    GetCitiesBySenderResponseT,
    GetCityResponse,
    GetRegionsListResponseT,
    GetRegionsResponseT,
    GetZonesResponseT,
    RegionPayloadT,
    RegionResponseT,
    UpdateCityPayloadT,
} from '../types/cities.types'

const citiesRepository = new CitiesRepository()

export class CitiesService {
    async getAllList(
        page: number,
        search?: string,
        limit?: number,
        regionId?: number,
        statusId?: number,
        postCode?: string
    ): Promise<GetAllCitiesResponseT> {
        const response = await citiesRepository.getAllList(
            page,
            search,
            limit,
            regionId,
            statusId,
            postCode
        )
        return response.data
    }

    async getCity(city_id: number): Promise<GetCityResponse> {
        const response = await citiesRepository.getCity(city_id)
        return response.data
    }

    async getRegionsList(
        page: number,
        search?: string,
        limit?: number
    ): Promise<GetRegionsListResponseT> {
        const response = await citiesRepository.getRegionsList(page, search, limit)
        return response.data
    }

    async getZonesList(page: number, search?: string): Promise<GetZonesResponseT> {
        const response = await citiesRepository.getZonesList(page, search)
        return response.data
    }

    async getRegions(): Promise<GetRegionsResponseT> {
        const response = await citiesRepository.getRegions()
        return response.data
    }

    async getCitiesBySender(sender_id: number): Promise<GetCitiesBySenderResponseT> {
        const response = await citiesRepository.getCitiesBySender(sender_id)
        return response.data
    }

    async createCity(payload: CityPayloadT): Promise<CityResponseT> {
        const response = await citiesRepository.createCity(payload)
        return response.data
    }

    async updateCity(city_id: number, city_payload: UpdateCityPayloadT): Promise<void> {
        await citiesRepository.updateCity(city_id, city_payload)
    }

    async deleteCity(city_id: number): Promise<void> {
        const response = await citiesRepository.deleteCity(city_id)
        return response.data
    }

    async createRegion(payload: RegionPayloadT): Promise<RegionResponseT> {
        const response = await citiesRepository.createRegion(payload)
        return response.data
    }

    async updateRegion(region_id: number, region_payload: RegionPayloadT): Promise<void> {
        await citiesRepository.updateRegion(region_id, region_payload)
    }

    async enableAvia(id: number): Promise<void> {
        await citiesRepository.enableAvia(id)
    }

    async disableAvia(id: number): Promise<void> {
        await citiesRepository.disableAvia(id)
    }

    async deleteRegion(region_id: number): Promise<void> {
        const response = await citiesRepository.deleteRegion(region_id)
        return response.data
    }
}
